{
  "INTEGRATION_APPS": {
    "FETCHING": "Récupération des intégrations",
    "NO_HOOK_CONFIGURED": "Aucune intégration {integrationId} n'est configurée dans ce compte.",
    "HEADER": "Applications",
    "STATUS": {
      "ENABLED": "Activé",
      "DISABLED": "Désactivé"
    },
    "CONFIGURE": "Configurer",
    "ADD_BUTTON": "Ajouter un nouveau hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirmer la suppression",
        "ACCOUNT": "Déconnecter"
      },
      "MESSAGE": {
        "INBOX": "Êtes-vous sûr de vouloir supprimer?",
        "ACCOUNT": "Êtes-vous sûr de vouloir déconnecter?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Oui, supprimer",
        "ACCOUNT": "Oui, déconnecter"
      },
      "CANCEL_BUTTON_TEXT": "Annuler",
      "API": {
        "SUCCESS_MESSAGE": "Webhook supprimé avec succès",
        "ERROR_MESSAGE": "Impossible de se connecter au serveur Woot, veuillez réessayer plus tard"
      }
    },
    "LIST": {
      "FETCHING": "Récupération des webhooks de l'intégration",
      "INBOX": "Boîte de réception",
      "EDIT": {
        "BUTTON_TEXT": "Modifier"
      },
      "DELETE": {
        "BUTTON_TEXT": "Supprimer"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Sélectionner la boîte de réception",
          "PLACEHOLDER": "Sélectionner la boîte de réception"
        },
        "SUBMIT": "Créer",
        "CANCEL": "Annuler"
      },
      "API": {
        "SUCCESS_MESSAGE": "Hook d'intégration ajouté avec succès",
        "ERROR_MESSAGE": "Impossible de se connecter au serveur Woot, veuillez réessayer plus tard"
      }
    },
    "EDIT": {
      "TITLE": "Modifier {name}",
      "FORM": {
        "INBOX": {
          "LABEL": "Sélectionner une boîte de réception",
          "PLACEHOLDER": "Sélectionner une boîte de réception"
        },
        "SUBMIT": "Mettre à jour",
        "CANCEL": "Annuler"
      },
      "API": {
        "SUCCESS_MESSAGE": "Crochet d'intégration mis à jour avec succès",
        "ERROR_MESSAGE": "Impossible de se connecter au serveur de chat, veuillez réessayer plus tard"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Connecter"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Déconnecter"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Récupérez des données depuis votre propre serveur et affichez-les dans la barre latérale de la conversation. Renvoie du HTML (affiché dans une iframe) ou du JSON (affiché sous forme de liste clé/valeur).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Synchronisez les e-mails et les webchats avec votre compte Daktela.",
      "RETINO": "Retino met de l'ordre dans la gestion des retours et des réclamations.",
      "MAILSHIP": "Mailship est un système de gestion d'entrepôt et d'exécution des commandes. Consultez le statut des commandes, le suivi et les détails d'expédition.",
      "RAYNET": "Connectez votre compte Raynet CRM pour accéder aux données de vos clients. Ajoutez une connexion avec votre nom d'utilisateur et votre jeton API Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Tester la connexion",
      "SUCCESS": "Connexion réussie",
      "ERROR": "Échec de la connexion. Veuillez vérifier vos identifiants."
    }
  }
}
